var faq = document.getElementsByClassName('faq-page');

function closeOthers(j) {
  for (let k = 0; k < faq.length; k++) {
    if (k !== j) {
      let body = faq[k].lastElementChild;
      if (body.style.maxHeight) {
        body.style.maxHeight = null;
        const element = faq[k].children;
        element[1].classList.toggle('active');
      }
    }
  }
}

for (let i = 0; i < faq.length; i++) {
  faq[i].addEventListener('click', function () {
    const element = this.children;
    element[1].classList.toggle('active');

    var body = this.lastElementChild;
    if (body.style.maxHeight) {
      body.style.maxHeight = null;
    } else {
      body.style.maxHeight = body.scrollHeight + 'px';
      closeOthers(i);
    }

    // for (j = 0; j < faq.length; j++) {
    //   if (j !== i) {
    //     body.style.maxHeight = null;
    //   }
    // }
  });
}
